import getConfig from 'next/config';

/**
 * @async
 * @param {string} language
 * @param {*} bodyObject
 * @param {() => void} successCB
 * @param {() => void} errorCB
 * @param {string | undefined} [endpoint]
 * @returns {*}
 */
const post = async (language, bodyObject, successCB, errorCB, endpoint) => {
  const { publicRuntimeConfig } = getConfig();

  try {
    const confirmationResponse = await fetch(
      `${publicRuntimeConfig.jobAlertApiBaseUrl}/${endpoint || ''}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Accept-Language': language,
        },
        body: JSON.stringify(bodyObject),
      },
    );
    if (confirmationResponse.status === 200) {
      successCB();
    } else {
      errorCB();
    }
  } catch {
    errorCB();
  }
};

export default {
  post,
};
